import { NgModule } from '@angular/core';
import { LogoutComponent } from './logout.component';
import { CommonModule } from '@angular/common';
import { EdAssistUIButtonLinkModule } from '@edassist-ui/button-link';
import { EdAssistUIModalModule } from '@edassist-ui/modal';
import { EdAssistUIIconModule } from '@edassist-ui/icon';
import { EdAssistUIParagraphModule } from '@edassist-ui/paragraph';
import { EdAssistUIButtonModule } from '@edassist-ui/button';
import { EdAssistUIFormsModule } from '@edassist-ui/forms';

const COMPONENTS = [LogoutComponent];

@NgModule({
	exports: COMPONENTS,
	declarations: COMPONENTS,
	imports: [
		CommonModule,
		EdAssistUIButtonModule,
		EdAssistUIButtonLinkModule,
		EdAssistUIModalModule,
		EdAssistUIIconModule,
		EdAssistUIParagraphModule,
		EdAssistUIFormsModule
	]
})
class EdAssistUILogoutModule {}

export { EdAssistUILogoutModule, LogoutComponent };
